// material-ui
import {Box, SxProps} from '@mui/system';

// project-imports

// import useAuth from 'hooks/useAuth';
import AuthSideImg from 'assets/images/icons/rosteric_logo_nobg.png';
import LogoMiniIconImg from 'assets/images/icons/logo192.png';

import React from 'react';
interface LogoSectionProps {
    isIcon?: boolean;
    sx?: SxProps;
}

// ==============================|| MAIN LOGO ||============================== //

export const LogoSection: React.FC<LogoSectionProps> = ({isIcon, sx}) => {
    if (isIcon)
        return <img src={LogoMiniIconImg} alt="Authimg" style={{height: '40px', width: '40px', padding: '5px'}} />;
    return (
        <Box display="flex" justifyContent={'flex-start'} width={'100%'} padding={'5px'}>
            <img src={AuthSideImg} alt="Authimg" width="150" height="40" style={{marginLeft: '12px'}} />
        </Box>
    );
};
